export default {
  listAccountPlans: [],
  accountPlan: {
    classe: '',
    codNatureza: '',
    ativo: true,
  },
}
